<script>
    import Dropdown from './Dropdown.svelte'

    import { 
        company, 
        domains,
        toDomainOption,
    }  from './stores.js'

    export let domain = null
    export let onDomainSelected = () => false

    const domainsFiltered = $domains.filter(i => i.company === $company.id )

    $: options  = domainsFiltered.map(item => toDomainOption(item))
    $: selected = domain ? toDomainOption(domain) : null
    $: noOption = domainsFiltered.length === 0
    
    function onChange(it) {
        onDomainSelected(it)
    }


</script>

    <div style="display: flex; justify-content: flex-start">

        <Dropdown   text="Domínios"
                    {noOption}
                    {options}
                    {selected}
                    {onChange}
                    />
    </div>


